import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelectBox } from './SelectBox';

type ReturnType = {
  value: string;
  setValue: (value: string) => void;
  isValid: boolean;
  CustomDatePicker: JSX.Element;
};

export function useDatePicker(): ReturnType {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>('');
  const yearSelectbox = useSelectBox({
    name: 'year',
    validate: {
      required: (value: string) => !!value,
    },
    placeholder: t('account/age/year_placeholder'),
    list: Array(100)
      .fill(new Date().getFullYear())
      .map((value, index) => value - index),
    component: function component(data) {
      return (
        <option key={data} value={data}>
          {data}
        </option>
      );
    },
    errors: {},
  });
  const monthSelectbox = useSelectBox({
    name: 'month',
    validate: {
      required: (value: string) => !!value,
    },
    placeholder: t('account/age/month_placeholder'),
    list: Array(12)
      .fill(1)
      .map((value, index) => value + index),
    component: function component(data) {
      return (
        <option key={data} value={data}>
          {data}
        </option>
      );
    },
    errors: {},
  });
  const dateSelectbox = useSelectBox({
    name: 'date',
    validate: {
      required: (value: string) => !!value,
    },
    placeholder: t('account/age/date_placeholder'),
    list: Array(
      dayjs()
        .year(+yearSelectbox.value)
        .month(+monthSelectbox.value - 1 || 1)
        .daysInMonth(),
    )
      .fill(1)
      .map((value, index) => value + index),
    component: function component(data) {
      return (
        <option key={data} value={data}>
          {data}
        </option>
      );
    },
    errors: {},
  });

  useEffect(() => {
    setValue(
      [
        yearSelectbox.value,
        (+monthSelectbox.value < 10 ? '0' : '') + monthSelectbox.value,
        (+dateSelectbox.value < 10 ? '0' : '') + dateSelectbox.value,
      ].join(''),
    );
  }, [yearSelectbox.value, monthSelectbox.value, dateSelectbox.value]);

  return {
    value,
    setValue,
    isValid: !!(yearSelectbox.value && monthSelectbox.value && dateSelectbox.value),
    CustomDatePicker: (
      <div className="flex">
        <div className="w-1/3 mr-1.5">{yearSelectbox.CustomSelectBox}</div>
        <div className="w-1/3 mr-1.5">{monthSelectbox.CustomSelectBox}</div>
        <div className="w-1/3">{dateSelectbox.CustomSelectBox}</div>
      </div>
    ),
  };
}
